import React, { Component } from 'react';
import { withRouter } from 'utilities';

import resourceHubThumb from 'images/homepage/homepage-resource-hub-thumb.png';
import mapThumb from 'images/homepage/homepage-map-thumb.png';

class TQPSHomepagePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            app_window_animation: '',
        };
    }

    componentDidMount() {
        let url = '/api/csrf/';
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            url = 'http://localhost:8000' + url;
        }
        fetch(url, {
            credentials: 'include',
        });
    }

    render() {
        return (
            <div className="homepage-wrapper">
                <div className="homepage-text">
                    <h2>
                        <span className="homepage-title-the">The </span>Constellation Network
                    </h2>
                    <h3>
                        facilitates connections among organizations, groups, and projects that support LGBTQ+
                        people forcibly confined in (or recently released from) prisons, jails, detention
                        centers, and psychiatric facilities.
                    </h3>
                    <h3>
                        Through this collaboration, we are deepening our collective capacity and skill to move
                        in solidarity with trans and queer prisoners.
                    </h3>
                </div>

                <div className="homepage-sections">
                    <div className="homepage-section homepage-section--reverse">
                        <div className="homepage-section-inner">
                            <div className="homepage-section-text" onClick={() => this.props.navigate('/resources')}>
                                <h2>Resource Hub</h2>
                                <p>
                                    Explore a wide variety of resources created by and for our LGBTQ+ family
                                    behind bars.
                                </p>
                            </div>
                            <div
                                className="homepage-section-image"
                                onClick={() => this.props.navigate('/resources')}
                            >
                                <img src={resourceHubThumb} alt="Resource Hub" />
                            </div>
                        </div>
                    </div>

                    <div className="homepage-section">
                        <div className="homepage-section-inner">
                            <div className="homepage-section-text" onClick={() => this.props.navigate('/map')}>
                                <h2>Org Map</h2>
                                <p>
                                    COMING SOON: Find a project near you that supports incarcerated or
                                    detained queer and trans people.
                                </p>
                            </div>
                            <div
                                className="homepage-section-image"
                                onClick={() => this.props.navigate('/map')}
                            >
                                <img src={mapThumb} alt="Resource Hub" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const TQPSHomepage = withRouter(TQPSHomepagePage);
export default TQPSHomepage;
